<aside class="drawer" [class.on]="!!doc" role="dialog" aria-modal="true" aria-labelledby="df-dr-title">
  <ng-container *ngIf="doc as d">
    <div class="dr-h">
      <df-file-badge [ext]="d.ext"></df-file-badge>
      <div style="flex:1;min-width:0">
        <h3 id="df-dr-title">{{ d.name }}</h3>
        <div class="d-path">{{ d.path }}</div>
      </div>
      <button type="button" class="icon-btn close-btn" style="color:var(--ink-2)" aria-label="Close" (click)="close()"><df-icon name="x"></df-icon></button>
    </div>

    <div class="dr-b">
      <div class="pills">
        <span class="pill" [style.border-color]="docTypes[d.t].color" [style.color]="docTypes[d.t].color">{{ docTypes[d.t].short }}</span>
        <span class="pill" [ngClass]="df.coverageLandscape(d)">{{ landscapeLabel(df.coverageLandscape(d), true) }}</span>
        <span class="pill code" *ngFor="let x of d.l2">{{ x }}</span>
        <span class="pill warn" *ngIf="d.flag">{{ d.flag }}</span>
      </div>

      <p class="lbl" style="margin-top:18px">Why the agent picked it</p>
      <div class="excerpt">{{ d.why }}</div>

      <!-- Process mapping section -->
      <p class="lbl" style="margin-top:18px">Process mapping</p>
      <div class="excerpt">
        <strong>L2 processes</strong>
        <ul style="margin:8px 0 0;padding-left:18px">
          <li *ngFor="let l2 of d.l2">{{ l2 }}</li>
          <li *ngIf="!d.l2.length">—</li>
        </ul>
        <div style="margin-top:8px">
          <strong>Document type:</strong> {{ docTypes[d.t].long }}<span *ngIf="d.src"> ({{ sourceName(d.src) }})</span>
        </div>
      </div>

      <!-- What's in this document section -->
      <p class="lbl" style="margin-top:18px">What's in this document</p>
      <div class="excerpt">
        <strong>{{ docTypes[d.t].long }}</strong><span *ngFor="let l2 of d.l2"> for <strong>{{ l2 }}</strong></span>.
        <span *ngIf="previewLoading">Loading preview…</span>
        <span *ngIf="!previewLoading && preview" style="white-space:pre-wrap">{{ preview }}</span>
        <span *ngIf="!previewLoading && !preview && d.summary">{{ d.summary }}</span>
        <span *ngIf="!previewLoading && !preview && !d.summary">No readable text. Use "Open document" to view it.</span>
      </div>

      <p class="hint err" *ngIf="openError" role="alert">{{ openError }}</p>

      <!-- Duplicates collapsed into this one section -->
      <p class="lbl" style="margin-top:18px" *ngIf="d.copies?.length">Duplicates collapsed into this one</p>
      <div class="excerpt" *ngFor="let copy of d.copies">
        <span class="flag-badge">ⓝ</span>{{ copy.name }}<br>
        <small style="color:var(--ink-3)">{{ copy.path }}</small>
      </div>

      <p class="lbl" style="margin-top:18px">Signals checked</p>
      <ul class="sig">
        <li *ngFor="let s of signals; let i = index" [class.y]="d.sig[i]" [class.n]="!d.sig[i]">
          <span class="ic">{{ d.sig[i] ? '✓' : '✕' }}</span>
          <div>{{ s[0] }}<small>{{ s[1] }}</small></div>
        </li>
      </ul>

      <dl class="kv" style="margin-top:16px">
        <dt>Source</dt><dd>{{ sourceName(d.src) }}</dd>
        <dt>Modified (as listed)</dt><dd>{{ d.mod }}</dd>
        <dt>Listing row</dt><dd>{{ d.id }}</dd>
        <dt>Codes found</dt><dd>{{ d.codes.length ? d.codes.join(', ') : '—' }}</dd>
      </dl>
    </div>

    <div class="dr-f">
      <button *ngIf="!d.signavioFlowId" type="button" class="btn ghost" (click)="openDocument(d.id)"><df-icon name="externalLink" [size]="14"></df-icon>Open document</button>
      <button *ngIf="d.signavioFlowId" type="button" class="btn ghost" [disabled]="downloading" (click)="downloadFlow(d)"><df-icon name="dl" [size]="14"></df-icon>{{ downloading ? 'Preparing flow...' : 'Download flow' }}</button>
      <span style="flex:1"></span>
      <button type="button" class="btn" (click)="close()">Close</button>
      <button type="button" class="btn exclude-btn" (click)="exclude(d.id)"><df-icon name="x" [size]="14"></df-icon>Mark irrelevant</button>
      <button type="button" class="btn pri include-btn" (click)="include(d.id)"><df-icon name="check" [size]="14"></df-icon>Mark relevant</button>
    </div>
  </ng-container>
</aside>
